import type { ReactNode } from 'react';

export const symbol_expansion_panels: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m480-330-87-87q-9-9-22-9t-22 9q-9 9-9 21.83 0 12.84 9 22.17l110 110q9 9 21 9t21-9l110-110q9-9.33 9-22.17 0-12.83-9-21.83-9-9-21.83-9-12.84 0-22.17 9l-87 87Zm0-300 87 87q9 9 22 9t22-9q9-9 9-21.83 0-12.84-9-22.17L501-697q-9-9-21-9t-21 9L349-587q-9 9-9 22t9 22q9 9 21.83 9 12.84 0 22.17-9l87-87ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
